import { FC } from 'react';
import { Box } from '@mui/system';
import { Outlet } from 'react-router-dom';

import { TopBar } from '../components/TopBar';
import { defineStyles } from '../theme';

const styles = defineStyles({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
});

const MainLayout: FC<{ qreId: string }> = ({ qreId }) => {
  return (
    <Box component="section" sx={styles.root}>
      <TopBar qreId={qreId} />
      <Outlet />
    </Box>
  );
};

export default MainLayout;
